import { Link } from 'react-router-dom';
import SEOHead from '@/components/base/SEOHead';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://superbuyspread.pics';

const faqs = [
  {
    q: 'What is Superbuy Sheet?',
    a: 'Superbuy Sheet is an organized product discovery resource that helps shoppers find products across 14 curated categories including shoes, hoodies, jackets, bags, accessories, and more. It provides structured spreadsheets with updated product listings, making international shopping faster and more efficient than traditional manual browsing.',
  },
  {
    q: 'How do I use Superbuy Sheet to find products?',
    a: 'Simply browse the category you are interested in, click through to explore products on the main platform, and use the organized spreadsheet data to compare options. Each category page is regularly updated with fresh finds, and you can navigate directly to any product listing from the spreadsheet interface.',
  },
  {
    q: 'Is Superbuy Sheet free to use?',
    a: 'Yes, Superbuy Sheet resources are completely free to access. Simply visit the main website or explore our category guides here to start discovering products. There are no sign-up fees or hidden charges for accessing the organized product spreadsheets and shopping guides.',
  },
  {
    q: 'How often are the categories updated?',
    a: 'Product categories and spreadsheets on Superbuy Sheet are updated weekly to ensure you have access to the latest products, trends, and new arrivals. The research team continuously monitors product availability and refreshes listings to keep the database current and reliable.',
  },
  {
    q: 'Can I shop internationally with Superbuy Sheet?',
    a: 'Absolutely. Superbuy Sheet is designed specifically for international shoppers looking to discover products across global marketplaces. The organized spreadsheet format makes it easy to find, compare, and select products regardless of your location, with clear category organization for efficient browsing.',
  },
];

const faqJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map((faq) => ({
    '@type': 'Question',
    name: faq.q,
    acceptedAnswer: {
      '@type': 'Answer',
      text: faq.a,
    },
  })),
};

export default function FAQSection() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <SEOHead jsonLd={faqJsonLd} />
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 text-xs font-semibold text-secondary-700 bg-secondary-100 rounded-full">
            FAQ
          </span>
          <h2 className="mt-4 font-heading text-3xl md:text-4xl font-bold text-foreground-900 tracking-tight">
            Frequently Asked{' '}
            <span className="text-accent-600">Questions</span>
          </h2>
        </div>

        <div className="max-w-3xl mx-auto space-y-4">
          {faqs.map((faq, idx) => (
            <details
              key={idx}
              className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden cursor-pointer"
            >
              <summary className="flex items-center justify-between px-6 py-5 text-foreground-900 font-semibold text-sm md:text-base list-none">
                {faq.q}
                <span className="w-6 h-6 flex items-center justify-center flex-shrink-0 ml-4">
                  <i className="ri-add-line text-lg text-foreground-400 group-open:hidden"></i>
                  <i className="ri-subtract-line text-lg text-foreground-400 hidden group-open:block"></i>
                </span>
              </summary>
              <div className="px-6 pb-5 text-foreground-500 text-sm leading-relaxed">
                {faq.a}
              </div>
            </details>
          ))}
        </div>

        <div className="mt-8 text-center">
          <Link
            to="/article/superbuy-sheet-complete-guide"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 text-sm font-semibold rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            Read the Full Guide
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}